import React from "react";

const Logo = ({ width = 200, height = 50, darkMode = false }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 800 200"
  >
    <defs>
      {/* Blur filter for glow */}
      <filter id="logo-blur" x="-100%" y="-100%" width="300%" height="300%">
        <feGaussianBlur in="SourceGraphic" stdDeviation="8" />
      </filter>
    </defs>

    <rect width="800" height="200" fill="transparent" />

    {/* Gold glow boxes - animated back and forth */}
    <g filter="url(#logo-blur)">
      <rect x="230" y="40" width="50" height="50" fill="#FFD700">
        <animate attributeName="opacity" values="0.2;1;0.2" dur="2s" repeatCount="indefinite" begin="0s" />
      </rect>
      <rect x="290" y="40" width="50" height="50" fill="#FFD700">
        <animate attributeName="opacity" values="0.2;1;0.2" dur="2s" repeatCount="indefinite" begin="0.4s" />
      </rect>
      <rect x="350" y="40" width="50" height="50" fill="#FFD700">
        <animate attributeName="opacity" values="0.2;1;0.2" dur="2s" repeatCount="indefinite" begin="0.8s" />
      </rect>
      <rect x="410" y="40" width="50" height="50" fill="#FFD700">
        <animate attributeName="opacity" values="0.2;1;0.2" dur="2s" repeatCount="indefinite" begin="1.2s" />
      </rect>
      <rect x="470" y="40" width="50" height="50" fill="#FFD700">
        <animate attributeName="opacity" values="0.2;1;0.2" dur="2s" repeatCount="indefinite" begin="1.6s" />
      </rect>
    </g>

    {/* Crisp foreground layer */}
    <text
      x="20"
      y="100"
      fontFamily="Times, serif"
      fontWeight="bold"
      fontSize="90"
      fill={darkMode ? "#004d25" : "white"}
    >
      SBG
    </text>
    <text
      x="20"
      y="150"
      fontFamily="Arial, sans-serif"
      fontSize="24"
      fill={darkMode ? "#004d25" : "white"}
    >
      Scott Business Group
    </text>
    {/* Color rectangles with conditional styling */}
    <rect
      x="230"
      y="40"
      width="50"
      height="50"
      fill={darkMode ? "#004d25" : "white"}
      opacity={darkMode ? "1" : "0.95"}
    />
    <rect
      x="290"
      y="40"
      width="50"
      height="50"
      fill={darkMode ? "#1e6738" : "white"}
      opacity={darkMode ? "1" : "0.85"}
    />
    <rect
      x="350"
      y="40"
      width="50"
      height="50"
      fill={darkMode ? "#338b4d" : "white"}
      opacity={darkMode ? "1" : "0.75"}
    />
    <rect
      x="410"
      y="40"
      width="50"
      height="50"
      fill={darkMode ? "#66b37d" : "white"}
      opacity={darkMode ? "1" : "0.65"}
    />
    <rect
      x="470"
      y="40"
      width="50"
      height="50"
      fill={darkMode ? "#99d1a7" : "white"}
      opacity={darkMode ? "1" : "0.55"}
    />
  </svg>
);

export default Logo;
